import { type ReactElement, useState, useEffect } from 'react';
import type { IHeaderParams } from 'ag-grid-community';
import { NeonIcon } from '@ps-refarch-ux/neon';

export const SortableHeader = (props: IHeaderParams & { children?: ReactElement }) => {
  const { column, enableSorting, progressSort, displayName, children } = props;
  const [sortDirection, setSortDirection] = useState<string | null | undefined>(column.getSort());
  useEffect(() => {
    const sortChangedListener = () => {
      setSortDirection(column.getSort());
    };
    column.addEventListener('sortChanged', sortChangedListener);
    return () => {
      column.removeEventListener('sortChanged', sortChangedListener);
    };
  }, [column]);

  const handleSort = () => {
    if (enableSorting) {
      progressSort();
    }
  };

  return (
    <div
      className="ag-header-cell-label"
      role="presentation"
      onClick={handleSort}
      style={{
        cursor: enableSorting ? 'pointer' : 'default',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: '8px',
      }}
    >
      <span className="ag-header-cell-text">{displayName}</span>
      {children}
      {sortDirection === 'asc' && <NeonIcon dataIcon="arrow-upward" />}
      {sortDirection === 'desc' && <NeonIcon dataIcon="arrow-downward" />}
    </div>
  );
};
